// extracted by mini-css-extract-plugin
export default {"nav_link_bottom":"BottomLinks_nav_link_bottom__pgsW0","selected":"BottomLinks_selected__FjTz4"};